var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.417 2.11458C13.2569 2.11458 13.0984 2.14611 12.9505 2.20737C12.8026 2.26863 12.6683 2.35842 12.5551 2.47161L3.68027 11.3464L3.03382 13.7167L5.40412 13.0703L14.2789 4.19546C14.3921 4.08227 14.4819 3.9479 14.5432 3.80001C14.6044 3.65212 14.636 3.49361 14.636 3.33353C14.636 3.17346 14.6044 3.01495 14.5432 2.86706C14.4819 2.71917 14.3921 2.5848 14.2789 2.47161C14.1657 2.35842 14.0314 2.26863 13.8835 2.20737C13.7356 2.14611 13.5771 2.11458 13.417 2.11458ZM12.4403 0.975531C12.7499 0.847267 13.0818 0.78125 13.417 0.78125C13.7522 0.78125 14.0841 0.847267 14.3937 0.975531C14.7034 1.1038 14.9847 1.2918 15.2217 1.5288C15.4587 1.7658 15.6467 2.04716 15.775 2.35682C15.9033 2.66648 15.9693 2.99837 15.9693 3.33353C15.9693 3.6687 15.9033 4.00059 15.775 4.31025C15.6467 4.61991 15.4587 4.90127 15.2217 5.13827L6.22175 14.1383C6.13971 14.2203 6.03768 14.2795 5.92575 14.31L2.25909 15.31C2.02828 15.373 1.78144 15.3074 1.61227 15.1383C1.4431 14.9691 1.37755 14.7223 1.4405 14.4915L2.4405 10.8248C2.47102 10.7129 2.53023 10.6108 2.61227 10.5288L11.6123 1.5288C11.8493 1.2918 12.1306 1.1038 12.4403 0.975531Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.58e9c724190f0bcf5ea4074c014caa23.svg";
export { ForwardRef as ReactComponent };